import { useLang } from "../../i18n/LanguageContext";
import useCanvasAnimation from "../../hooks/useCanvasAnimation";
import HeroShortcuts from "./HeroShortcuts";

export default function Hero() {
  const { t } = useLang();
  const canvasRef = useCanvasAnimation();

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center pt-32 pb-24 bg-cover bg-center bg-no-repeat overflow-hidden select-none"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, rgba(17,17,18,0.88), rgba(17,17,18,0.98)), url('https://images.unsplash.com/photo-1513828583688-c52646db42da?auto=format&fit=crop&q=80&w=1920')",
      }}
    >
      <canvas ref={canvasRef} className="fixed top-0 left-0 w-full h-full pointer-events-none z-0 opacity-20" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(242,140,24,0.12)_0%,transparent_60%)]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10 space-y-8">
        <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-xs font-medium tracking-[0.2em] text-[#F28C18] uppercase animate-pulse">
          <span className="w-1.5 h-1.5 bg-[#F28C18] rounded-full" />
          {t.hero.badge}
        </div>

        <h1 className="text-4xl sm:text-6xl lg:text-8xl font-black tracking-tight text-white max-w-6xl mx-auto leading-[1.1] uppercase">
          {t.hero.title1} <br />
          {t.hero.title2} <span className="text-[#F28C18]">{t.hero.titleAccent}</span>
        </h1>

        <p className="text-base sm:text-xl text-zinc-400 max-w-4xl mx-auto font-light leading-relaxed">
          {t.hero.sub}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
          <a href="#contact" className="w-full sm:w-auto px-8 py-4 bg-[#F28C18] text-black font-black tracking-widest uppercase rounded text-xs shadow-xl shadow-orange-500/10 hover:bg-white transition-all duration-300">
            {t.hero.cta1}
          </a>
          <a href="#services" className="w-full sm:w-auto px-8 py-4 bg-white/5 border border-white/10 text-white font-black tracking-widest uppercase rounded text-xs hover:bg-white/10 transition-all duration-300">
            {t.hero.cta2}
          </a>
        </div>

        <HeroShortcuts />
      </div>
    </section>
  );
}
